import React, { Component } from "react";
import { Icon, Tag } from "antd";

class TestRunStatus extends Component {
  render() {
    const { tag } = this.props;
    const showIcon = props => {
      const status = props.status;

      let size = 22;
      if (props.size != undefined) size = props.size;

      if (status == "1")
        return tag ? (
          <Tag color="green">Passed</Tag>
        ) : (
          <Icon
            type="check-circle"
            style={{ fontSize: size, color: "rgb(85, 167, 65)" }}
            title="Passed"
            theme="filled"
          />
        );
      if (status == "0")
        return tag ? (
          <Tag color="red">Unexecuted</Tag>
        ) : (
          <Icon
            type="ellipsis"
            style={{
              fontSize: "15px",
              color: "#fff",
              //verticalAlign: "sub",
              backgroundColor: "#d2d2ce",
              borderRadius: "50px",
              border: "1px solid #d2d2ce",
              padding: "2.5px"
            }}
            title="Unexecuted"
            //theme="filled"
          />
        );
      if (status == "2")
        return tag ? (
          <Tag color="red">Unexecuted</Tag>
        ) : (
          <Icon
            type="close-circle"
            style={{ fontSize: size, color: "rgb(183, 58, 58)" }}
            title="Failed"
            theme="filled"
          />
        );
      if (status == "3")
        return tag ? (
          <Tag color="yellow">Skipped</Tag>
        ) : (
          <Icon
            type="exclamation-circle"
            style={{ fontSize: size, color: "rgb(224, 175, 26)" }}
            title="Skipped"
            theme="filled"
          />
        );
      if (status == "4")
        return tag ? (
          <Tag color="#163088">Blocked</Tag>
        ) : (
          <Icon
            type="stop"
            style={{ fontSize: size, color: "rgb(65, 115, 167)" }}
            title="Blocked"
            theme="filled"
          />
        );
      if (status == "" || status == null)
        return tag ? (
          <Tag color="blue">Unexecuted</Tag>
        ) : (
          <Icon
            type="ellipsis"
            style={{
              fontSize: "15px",
              color: "#fff",
              //verticalAlign: "sub",
              backgroundColor: "#d2d2ce",
              borderRadius: "50px",
              border: "1px solid #d2d2ce",
              padding: "2.5px"
            }}
            title="Unexecuted"
          />
        );
    };

    const showLabelFn = status => {
      if (status == "1") return "Passed";
      if (status == "2") return "Failed";
      if (status == "0") return "Unexecuted";
      if (status == "3") return "Skipped";
      if (status == "4") return "Blocked";
      if (status == "unexecuted" || status == null) return "Unexecuted";
    };

    let showLabel = false;
    if (this.props.label != undefined && this.props.label == true)
      showLabel = true;

    return (
      <div style={{ display: "inline" }}>
        {showIcon(this.props)} &nbsp;
        {showLabel ? showLabelFn(this.props.status) : ""}
      </div>
    );
  }
}
export default TestRunStatus;
